<template>
  <div>
    <div class="chart" ref="myEchart" />
  </div>
</template>
<script>
import axios from 'axios'
import * as echarts from 'echarts'
import { use } from 'echarts/core'
import { CanvasRenderer } from 'echarts/renderers'
import { LineChart } from 'echarts/charts'

use([CanvasRenderer, LineChart])

export default {
  name: 'trend_chart_2',
  components: {
    echarts,
  },
  data() {
    return {
      reportData: null,
      chart: null,
    }
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },

  async mounted() {
    await this.fetchData()
  },
  watch: {
    $route: 'fetchData',
  },
  methods: {
    fetchData() {
      const apiUrl = process.env.VUE_APP_SERVICE_URL
      axios
        .get(`${apiUrl}/api/cluster_immunization/fetch_trend_new`)
        .then((res) => {
          let result = Object.freeze(res.data)

          // ambil value aja dari array of object
          let arr = result.map(function (element) {
            return Object.values(element)
          })
          var header = ['value', 'date', 'title', 'date_label', 'key']
          arr.unshift(header)

          this.reportData = arr
          if (this.reportData) this.initChart()
        })
        .catch((err) => {
          console.log(err)
        })
    },

    initChart() {
      this.chart = echarts.init(this.$refs.myEchart)
      let option = null
      this.chart.showLoading()
      this.chart.hideLoading()

      // filter which data need to be visualized
      let titles = [
        'Total Dosis 1',
        'Total Dosis 2',
        'Total Dosis 3',
        // 'SDMK Dosis 1',
        // 'SDMK Dosis 2',
        // 'Pet. Publik Dosis 1',
        // 'Pet. Publik Dosis 2',
        // 'Lansia Dosis 1',
        // 'Lansia Dosis 2',
        // 'Masy Umum dan Rentan Dosis 1',
        // 'Masy Umum dan Rentan Dosis 2',
        // 'Remaja Dosis 1',
        // 'Remaja Dosis 2',
      ]
      let datasetWithFilters = []
      let seriesList = []

      echarts.util.each(titles, function (title) {
        let datasetId = 'dataset_' + title
        datasetWithFilters.push({
          id: datasetId,
          fromDatasetId: 'dataset_raw',
          transform: {
            type: 'filter',
            config: {
              and: [
                { dimension: 'date', gte: 1614531600 },
                { dimension: 'title', '=': title },
              ],
            },
          },
        })
        seriesList.push({
          type: 'line',
          datasetId: datasetId,
          showSymbol: false,
          name: title,
          endLabel: {
            show: true,
            formatter: function (params) {
              return params.value[2] + ': ' + params.value[0]
            },
          },
          labelLayout: {
            moveOverlap: 'shiftY',
          },
          emphasis: {
            focus: 'series',
          },
          encode: {
            x: 'date_label',
            y: 'value',
            label: ['Title', 'Value'],
            itemName: 'date_label',
            tooltip: ['Value'],
          },
        })
      })

      option = {
        animationDuration: 10000,
        dataset: [
          {
            id: 'dataset_raw',
            source: this.reportData,
          },
        ].concat(datasetWithFilters),
        title: {
          text: '',
        },
        tooltip: {
          order: 'valueDesc',
          trigger: 'axis',
        },
        xAxis: {
          type: 'category',
          nameLocation: 'middle',
        },
        yAxis: {
          name: '',
        },
        grid: {
          right: 140,
        },
        series: seriesList,
      }

      if (option && typeof option === 'object') {
        this.chart.setOption(option, true)
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.chart {
  height: 400px;
  margin-top: -15px;
}
</style>
